/**
 * PhoneInput
 *
 * Preconfigured `Input` wrapper for telephone number entry.
 * Sets `type="tel"`, `inputMode="tel"`, and defaults `leftContent` to a phone icon.
 * Callers may override `leftContent` with a different icon if needed.
 */
import * as React from 'react';
import { Input, type InputProps } from './Input';
import { Icon } from '../icons/Icon';

export type PhoneInputProps = Omit<InputProps, 'type'>;

export const PhoneInput = React.forwardRef<HTMLInputElement, PhoneInputProps>(
  ({ leftContent, ...props }, ref) => (
    <Input
      {...props}
      type='tel'
      inputMode='tel'
      leftContent={leftContent ?? <Icon name='phone' />}
      ref={ref}
    />
  )
);

PhoneInput.displayName = 'PhoneInput';
